jQuery( document ).ready(function( $ ) {
  // Otimizar carregamento de imagens com Intersection Observer
if ('IntersectionObserver' in window) {
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        
        // Carregar imagem
        if (img.dataset.src) {
          img.src = img.dataset.src;
        }
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
        }
        
        // Adicionar classe de carregado
        img.classList.add('loaded');
        
        // Parar de observar
        observer.unobserve(img);
      }
    });
  }, {
    rootMargin: '50px'
  });
  
  // Observar todas as imagens com lazy loading
  document.querySelectorAll('img[loading="lazy"]').forEach(img => {
    imageObserver.observe(img);
  });
}

// Adicionar botão Comprar mobile aos produtos
if (window.innerWidth <= 768) {
  document.addEventListener('DOMContentLoaded', function() {
    // Encontrar todos os itens de produto
    const productItems = document.querySelectorAll('.product-item, .product-card, .collection-item, [class*="product"][class*="item"]');
    
    productItems.forEach(item => {
      // Verificar se já tem botão
      if (!item.querySelector('.mobile-buy-button')) {
        // Criar botão Comprar
        const buyButton = document.createElement('button');
        buyButton.className = 'mobile-buy-button';
        buyButton.textContent = 'Comprar';
        buyButton.type = 'button';
        
        // Adicionar evento de clique
        buyButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Encontrar o link do produto ou botão de adicionar ao carrinho
          const productLink = item.querySelector('a[href*="/products/"]');
          const addToCartBtn = item.querySelector('[class*="add-to-cart"], [class*="add_to_cart"], button[name="add"]');
          
          if (addToCartBtn) {
            addToCartBtn.click();
          } else if (productLink) {
            window.location.href = productLink.href;
          }
        });
        
        // Adicionar botão ao item
        item.appendChild(buyButton);
      }
      
      // Adicionar evento de toque para mostrar botão
      item.addEventListener('touchstart', function() {
        this.classList.add('touched');
      });
      
      // Remover classe após 3 segundos de inatividade
      item.addEventListener('touchend', function() {
        const self = this;
        setTimeout(() => {
          self.classList.remove('touched');
        }, 3000);
      });
    });
  });
}

// Ocultar botão do WhatsApp ao rolar para baixo em páginas de produto mobile
if (document.body.classList.contains('template-product')) {
  let lastScrollTop = 0;
  let scrollTimeout;
  
  window.addEventListener('scroll', function() {
    let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    
    // Limpar timeout anterior
    clearTimeout(scrollTimeout);
    
    // Se rolou para baixo mais de 300px, ocultar WhatsApp
    if (currentScroll > 300) {
      document.body.classList.add('whatsapp-hidden');
    } else {
      // Se voltou para o topo, mostrar WhatsApp
      document.body.classList.remove('whatsapp-hidden');
    }
    
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }, false);
}
});